export default __webpack_public_path__ + "static/media/7.9c793e54.png";